import "./instrument"; // Must be first import
import "./sdk-config"; // Wire SDK base URL before any data fetching
import "./i18n";
import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { applyBrandToDocument } from "./lib/brand";
import { applyTheme } from "./lib/theme";
import { applyConsent } from "./lib/consent";

applyBrandToDocument();
applyTheme();
applyConsent();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
